import Vue from 'vue';
import VueFormGenerator from 'vue-form-generator';
import OrganiserAccordion from '../../../organiser/OrganiserAccordion/OrganiserAccordion';

Vue.use(VueFormGenerator);

export default {

  name: 'StepTwo',

  components: {
    'organiser-accordion': OrganiserAccordion
  },

  inject: [
    'currentLocale',
    'removeFromCart',
    'storageData',
    'stepValidation',
    'getEventByUuid'
  ],

  data () {
    return {
      isStepValid: false,
      formOptions: {
        validateAfterChanged: true
      },
      OrganiserIsVisible: false
    };
  },

  computed: {
    dataProtectionLink: function () {
      if (this.currentLocale() === 'de') {
        return 'https://www.mercedes-benz.com/de/#datenschutz';
      } else {
        return 'https://www.mercedes-benz.com/en/#privacyStatement';
      }
    }
  },

  methods: {
    onValidated (isValid, errors) {
      if (!isValid) {
        this.isStepValid = false;
        Vue.set(this.stepValidation, 'triedToValidateStep', true);
      }
    },
    validateStep: function () {
      if (this.$refs.hasOwnProperty('toValidateForms')) {
        this.isStepValid = true;
        this.$refs.toValidateForms.forEach(function (form) {
          // trigger onValidated
          form.validate();
        });
      }
      Vue.set(this.stepValidation, 'isValid', this.isStepValid);
    },
    generateParticipantSchema: function (schemaId) {
      return this.generateSchema(schemaId, [
        {
          id: 'salutation',
          title: 'Anrede',
          required: true
        },
        {
          id: 'surname',
          title: 'Nachname',
          required: true
        },
        {
          id: 'firstname',
          title: 'Vorname',
          required: true
        },
        {
          id: 'phone',
          title: 'Telefon',
          required: true
        },
        {
          id: 'mobile',
          title: 'Mobilnummer während der Veranstaltung',
          required: false
        },
        {
          id: 'eMail',
          inputType: 'email',
          title: 'E-Mail',
          required: true
        },
        {
          id: 'birthday',
          title: 'Geburtsdatum',
          required: true
        }
      ]);
    },
    generateBillingSchema: function (schemaId) {
      return this.generateSchema(schemaId, [
        {
          id: 'firm',
          title: 'Firma',
          required: false
        },
        {
          id: 'street',
          title: 'Straße',
          required: true
        },
        {
          id: 'streetNumber',
          title: 'Hausnummer',
          required: true
        },
        {
          id: 'province',
          title: 'Provinz',
          required: false
        },
        {
          id: 'zip',
          title: 'PLZ',
          required: true
        },
        {
          id: 'city',
          title: 'Ort',
          required: true
        },
        {
          id: 'country',
          title: 'Land',
          required: true
        }
      ]);
    },
    generateSchema: function (schemaId, fields) {
      let fieldsWithAllData = [];
      let proxy = this;

      fields.forEach(function (field) {
        let overwrites = {};

        if (field.hasOwnProperty('inputType')) {
          overwrites = Object.assign({}, {
            'inputType': field.inputType,
            validator: VueFormGenerator.validators.email.locale({
              invalidEmail: proxy.$options.filters.trans('Ungültige Email.'),
              fieldIsRequired: proxy.$options.filters.trans('Bitte füllen Sie dieses Pflichtfeld.')
            })
          });
        }

        fieldsWithAllData.push(Object.assign({}, {
          type: 'input',
          inputType: 'text',
          label: proxy.$options.filters.trans(field.title),
          id: schemaId + field.id,
          model: field.id,
          readonly: false,
          featured: true,
          required: field.required,
          disabled: false,
          placeholder: proxy.$options.filters.trans(field.title),
          validator: VueFormGenerator.validators.string.locale({
            fieldIsRequired: proxy.$options.filters.trans('Bitte füllen Sie dieses Pflichtfeld.')
          })
        },
        overwrites
        )
        );
      });

      return {
        styleClasses: '',
        legend: 'Billing & Deliver Address',
        fields: fieldsWithAllData
      };
    }
  },

  created () {
    this.$parent.$off('validateCurrentStep').$on('validateCurrentStep', this.validateStep);
    Vue.set(this.stepValidation, 'isValid', false);

    let count = 0;
    for (let eventUuid in this.storageData.cart) {
      let cartEntry = this.storageData.cart[eventUuid];
      if (!this.storageData.forms.stepTwo.hasOwnProperty(eventUuid)) {
        Vue.set(this.storageData.forms.stepTwo, eventUuid, {
          'participantData': {},
          'billingAddress': {},
          'differentParticipantInformation': false,
          'differentBillingAddress': false
        });
      }
      count++;
    }
  },

  mounted () {
  }

};



// WEBPACK FOOTER //
// ./src/apps/booking/components/bookingSteps/defaultSteps/2/StepTwo.js